import styled from "styled-components";

export const StatisticsContainer = styled.div`
  padding: 5px;
  width: 100% !important;
  minWidth: 100% !important;
  height: calc(100vh - 300px);

  .powerBiStyle {
    width: 100% !important;
    height: 100% !important;
    minWidth: 100% !important;
  }

  .powerBiStyle iframe {
    width: 100% !important;
    height: 100% !important;
    minWidth: 100% !important;
  }
`;

export const FullHeightStatisticsContainer = styled(StatisticsContainer)`
  height: 100vh;
`;
